import { render, staticRenderFns } from "./EmiCommentsVerify.vue?vue&type=template&id=fd64b30c"
import script from "./EmiCommentsVerify.vue?vue&type=script&lang=js"
export * from "./EmiCommentsVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports